import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationsSidenavService {

  private sidenav: MatSidenav

  public newNotification: BehaviorSubject<boolean>;

  public dismissedNotif: BehaviorSubject<boolean>

  public notificationsData: BehaviorSubject<any[]>
  public sensorNotificationsData: BehaviorSubject<any[]>
  public dismissedNotificationData: BehaviorSubject<any[]>

  public notificationsArray: any[] = [];

  public sensorNotificationsArray: any[] = [];

  public sensorNotificationsLength: BehaviorSubject<number>;

  public dismissedNotificationsArray: any[] = [];

  private base_url: string;

  constructor() {
    this.base_url = environment.base_url;
    this.newNotification = new BehaviorSubject(false);
    this.dismissedNotif = new BehaviorSubject(false);
    this.notificationsData = new BehaviorSubject([]);
    this.sensorNotificationsData = new BehaviorSubject([]);
    this.dismissedNotificationData = new BehaviorSubject([]);
    this.sensorNotificationsLength = new BehaviorSubject(0);
  }

  setSidenav(sidenav: MatSidenav) {
    this.sidenav = sidenav;
  }

  /**
   * @returns Boolean
   */

  public open(): void {
    this.sidenav.open();
  }

  /**
   * @returns Boolean
   */

  public close(): void {
    this.sidenav.close();
  }

  /**
   * @returns Boolean
   */

  public toggle() {
    this.sidenav.toggle();
  }

  public transferNotifications(data: any) {
    this.transformToArrayNotifications(data)
  }

  public setNotificationsArray(data?: any[]) {
    if (data !== undefined) this.notificationsArray = [...data]
    this.notificationsData.next(this.notificationsArray)
  }

  public setSensorNotificationsArray(data?: any[]) {
    if (data !== undefined) this.sensorNotificationsArray = [...data]
    this.sensorNotificationsData.next(this.sensorNotificationsArray)
    this.sensorNotificationsLength.next(this.sensorNotificationsArray.length)
  }

  public setNewNotification(bool: boolean) {
    this.newNotification.next(bool)
  }

  public setDismissedNotif(bool: boolean) {
    this.dismissedNotif.next(bool)
  }

  private transformToArrayNotifications(data): any[] {

    this.notificationsArray = [...this.notificationsArray, ...data]
    // this.notificationsArray.push(data)
    // if (this.notificationsArray.length > 10) {
    //   for (var i = 0; i < 10; i++) {
    //     this.notificationsArray.pop()
    //   }
    // }
    this.setNotificationsArray()

    return this.notificationsArray
  }

  public get getNotifications() {
    return this.notificationsData
  }

  public get doWeHaveNewNotification() {
    return this.newNotification
  }

  public get doWeHaveNewlyDismissedNotif() {
    return this.dismissedNotif
  }

  // Dismissed Notifications

  public setDismissedNotificationsArray(data?: any[]) {
    if (data !== undefined) this.dismissedNotificationsArray = [...data]
    this.dismissedNotificationData.next(this.dismissedNotificationsArray)
  }

  public get getDismissedNotifications() {
    return this.dismissedNotificationData
  }
}


